<template>
  <div>
    <pt-form-item label="已审核委托单：" labelWidth="120px" v-if="PDF">
      <!-- <a
        target="_blank"
        style="dispaly:block">
        <el-button size="small" type="primary" plain>下载PDF</el-button>
        <span style="margin-left:20px">请下载后打印并寄送给客户</span>
      </a> -->
      <a :href="$privateResourcesUrl+order.reportOssUrl.replace(/\+/g, '%2B')" target="_blank" style="dispaly:block;text-decoration:none;">
        <span style="color:#409eff;border-bottom:1px solid #409eff">已审核委托单.PDF</span>
      </a>
      <a v-if="order.reportAttachmentOssUrl" :href="$privateResourcesUrl+order.reportAttachmentOssUrl.replace(/\+/g, '%2B')" target="_blank" style="dispaly:block;text-decoration:none;margin-left:20px">
        <span style="color:#409eff;border-bottom:1px solid #409eff">已审核委托单(附页).PDF</span>
      </a>
      <span style="margin-left:20px">请下载后打印并寄送给客户</span>
    </pt-form-item>

    <pt-form-item label="上传回传委托单：" labelWidth="120px">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" data-vv-as="上传回传委托单" listType="text" v-model="form.attachments">
        <el-button size="small" plain type="primary">上传扫描件</el-button>
        <span style="margin-left:20px">可上传客户回传的已签字委托单的扫描件</span>
      </wt-upload-file>
    </pt-form-item>
    <pt-form-item label="委托单编号：" labelWidth="120px" :required="true">
      <wt-input v-model="form.billCode" data-vv-as="委托单编号" v-validate="'required'" placeholder="请输入委托单编号" class="bill-input-BILL_BACK"></wt-input>
    </pt-form-item>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import { nextTrust } from '../status.js'
import { formatDate } from '@/utils/formUtils.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    orderStatus: [Array]
  },
  computed: {
    PDF () {
      return this.order?.attachments?.find(e => e.type === 'BILL_PDF_CHECK')
    }
  },
  data () {
    return {
      title: '待回传',
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'bill',
        objectId: this.order.id || 0
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      form: {
        result: 'REPORT_GENERATE',
        reason: '',
        qualityFile: [],
        billCode:`${this.getDateStr()}-YFC-`
      },
      // oss里存的路径+名字
      saveFileName: '',
      options: []
    }
  },
  watch: {
    qualityFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.qualityFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    getDateStr(){
      let dateStr = formatDate(new Date(),'date').split('-').join('')

      return dateStr.substring(2)
    },

    next () {
      let data = {
        billId: this.order.id,
        action: this.status,
        billStatusDetail: {
          action: this.status,
          billCode: this.form.billCode,
          attachmentFileInformationList: this.form.attachments?.map(item => {
            return {
              type: 'BILL_PDF_BACK',
              name: item.name,
              ossUrl: item.response
            }
          })
        }
      }
      return nextTrust.call(this, data)
    }
  },
  created () {

  }

}
</script>

<style lang="less">
.bill-input-BILL_BACK{
	max-width: 300px;
	.el-input__inner{
		width: 100%!important
	}
}
</style>
